export type Address = {
  address1: string | null;
  city: string | null;
  longitude: number | null;
  latitude: number | null;
  postal_code: string | null;
};

function formatAddress(address: Address) {
  const addressDetails = [address.postal_code, address.city];
  const addressConcatenate = addressDetails.filter(item => item).join(' ');

  if (address.address1) {
    return `${address.address1}, ${addressConcatenate}`;
  }
  if (address.postal_code || address.city) {
    return addressConcatenate;
  }
  if (address.longitude && address.latitude) {
    return `Coordonnées: ${Math.round(address.longitude)}, ${Math.round(address.latitude)}`;
  }

  return null;
}

export default formatAddress;
